import { useTranslation } from 'react-i18next';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, ButtonBase, Tooltip, Typography } from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';
//
import { MODES } from '../../store/constant';
import { SvgDarkFill, SvgLigntFill } from '../../components/SvgIcons';

// ================================|| Styled ||================================ //
const BoxStyle = styled(Box)(({ theme }) => ({
  ...theme.typography.hoverSecondaryUnderline2px,
  '& .MuiButtonBase-root': {
    height: '100%',
    padding: theme.spacing(0, 1.5),
    '&:hover': {
      svg: {
        transition: 'all .3s ease',
        // color: theme.palette.error.main,
        // fill: theme.palette.error.main,
      }
    }
  }
}));

// ================================|| Toggle Mode ||================================ //
export default function ToggleMode({ sx }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { themeMode, onToggleMode } = useSettings();
  return (
    <Tooltip
      arrow
      placement="bottom"
      title={
        <Typography variant={'body2'}>
          {/* '點擊切換至淺色模式' : '點擊切換至深色模式'} */}
          {[MODES.Dark].includes(theme.palette.mode) ? t('cgam.click.to.switch.to.light.mode') : t('cgam.click.to.switch.to.dark.mode')}
        </Typography>
      }
      PopperProps={{
        sx: {
          borderRadius: 6/9,
        },
      }}
      slotProps={{
        popper: {
          sx: {
            zIndex: 3
          },
        },
        tooltip: {
          sx: {
            borderRadius: 0,
            backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%)`,
            boxShadow: `0px 3px 14px 0px rgba(0, 0, 0, 0.05)`,
          },
        }
      }}
    >
      <BoxStyle onClick={onToggleMode}>
        <ButtonBase disableRipple>
          {
            [MODES.Dark].includes(theme.palette.mode) ? (
              <SvgDarkFill size="24" />
            ) : (
              <SvgLigntFill size="24" />
            )
          }
        </ButtonBase>
      </BoxStyle>
    </Tooltip>
  );
}
